// this directive doesn't support nesting itself
// remember to have only one instance of it running at a time

const focusableElements = 'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'

export default {
  beforeMount (el) {
    el.onKeyDown = e => {
      if (el.offsetWidth > 0 && el.offsetHeight > 0) {
        let isTabPressed = e.key === 'Tab' || e.keyCode === 9

        if (!isTabPressed) return

        const focusableContent = [...el.querySelectorAll(focusableElements)]
          .filter(item => {
            return !item.hasAttribute('disabled')
          })
        const firstFocusableElement = focusableContent[0]
        const lastFocusableElement = focusableContent[focusableContent.length - 1]

        if (!el.contains(document.activeElement) || document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus()
          e.preventDefault()
        } else if (e.shiftKey && document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus()
          e.preventDefault()
        }
      }
    }
    document.addEventListener('keydown', el.onKeyDown)
  },

  unmounted (el) {
    document.removeEventListener('keydown', el.onKeyDown)
  },
}
